'use strict';
import angular from 'angular';

import shoppingAdgroupSingleProductHtmlUrl from './views/shoppingAdgroupSingleProduct.list.html';

var app = angular.module('app.shoppingAdgroupSingleProductComponents', []);

app.component('shoppingAdgroupSingleproduct', {
    bindings: {
        adgroupSingleproduct: '=',
        showActions: "="
    },
    templateUrl: shoppingAdgroupSingleProductHtmlUrl,

    // The controller that handles our component logic
    controller: function($ioAlert, anchorSmoothScroll, $location, $timeout) {
        var self = this;
        self.adGroupProductFormObj = { type:"product"};
        self.adGroup = {};
        self.adTypeObj = { creativeImages:[] };
        self.adTypes = ["PRODUCT_AD", "EXPANDED_DYNAMIC_SEARCH_AD", "IMAGE_AD", "CALL_ONLY_AD", "SHOWCASE_AD", "PRODUCT_AD"];
        self.showAdGroupForm = false;
        self.showAdTypeForm = false;
        self.adGroupStatus = ["ENABLED", "PAUSED", "REMOVED"];
        self.isAdGroup = true;
        self.isAdType = false;

        //Show AdType by Sliding to the AdType View
        self.viewProductAdType = function(adgroup) {
            self.adgroupSingleproduct = adgroupSingleproduct;
            self.isAdGroup = false;
            self.showAdGroupForm = false;
            self.isAdType = true;
            //If there are no Adds create an Empty Array
            if (!self.adgroupSingleproduct.ads) {
                self.adgroupSingleproduct.ads = [];
            };
            if (self.adgroupSingleproduct.ads && self.adgroupSingleproduct.ads.length == 0 && self.showActions) {
                self.addAdType();
            };
        };

        //Show Ad Group Screen 
        self.backToAdGroup = function() {
            self.isAdGroup = true;
            self.isAdType = false;
            self.adGroup = {};
        }

        // Initialise Add group Form
        self.initAdGroup = function() {
            self.adGroupProductFormObj = {
                adGroupName: "",
                adGroupStatus: "",
                ad_group_cpc_bid:"",
                type:"product"
            };
        }

        //Show Add Group form 
        self.newAdGroup = function() {
            self.initAdGroup();
            self.showAdGroupForm = true;
            self.showAdTypeForm = false;
            self.isNewGroup = true;
        };

        //Hide Ad Group Form
        self.cancelAdGroup = function() {
            self.showAdGroupForm = false;
            self.initAdGroup();
        }

        // Edit Ad Group Form
        self.editProductAdGroup = function(adGroupProductFormObj, index) {
            self.showAdGroupForm = true;
            self.showAdTypeForm = false;
            self.adGroupProductFormObj = angular.copy(adGroupProductFormObj);
            self.groupIndex = index;
            self.isNewGroup = false;
            $location.hash('top-scroll-single');
            anchorSmoothScroll.scrollTo('top-scroll-single');
            $timeout(function() {
                $location.hash('');
            }, 500);
        }

        // Save AdGroup form
        self.saveAdGroup = function(form) {
            if (self.adGroupProductFormObj && self.adGroupProductFormObj.adGroupName != "" && self.adGroupProductFormObj.adGroupName != undefined && self.adGroupProductFormObj.adGroupStatus != "" && self.adGroupProductFormObj.ad_group_cpc_bid != "" && self.adGroupProductFormObj.ad_group_cpc_bid != undefined ) {
                if (self.isNewGroup === false) {
                    self.adgroupSingleproduct[self.groupIndex] = self.adGroupProductFormObj;
                } else {
                    if (!self.adgroupSingleproduct) {
                        self.adgroupSingleproduct = [];
                    };
                    self.adgroupSingleproduct.push(self.adGroupProductFormObj);
                }
                self.showAdGroupForm = false;
                self.initAdGroup();
            } else {
                $ioAlert.show('', 'Please fill the required fields', 'error');
            }
        }

        // Delete Ad Group Helper function
        self.delProductAdGroup = function(index) {
            self.showAdGroupForm = false;
            self.adgroupSingleproduct.splice(index, 1);
            if(self.adgroupSingleproduct.length == 0){
                console.log('this is dat');
                self.newAdGroup();
            }
        }


        /*
         * Update AdType Helper function to toggle Image Ad and expanded ad
         */
        self.updateAdType = function(type) {
            self.adTypeObj = {};
        };

        /*
         * Display Show AdType form
         */
        self.addAdType = function() {
            self.showAdTypeForm = true;
            self.isNewAd = true;
            self.adTypeObj = { };
        };

        /*
         * Display Edit Ad Type form
         */
        self.editAdType = function(ad, index) {
            self.showAdTypeForm = true;
            self.adTypeObj = angular.copy(ad);
            self.isNewAd = false;
            self.adIndex = index;
        }

        /*
         * Save/Edit Ad Type and update the AdGroup object
         */
        self.saveAdType = function(form) {
            if (form.$valid) {
                if (self.adgroupSingleproduct) {
                    if (!self.adgroupSingleproduct.ads) {
                        self.adgroupSingleproduct.ads = [];
                    }
                    if (self.isNewAd) {
                        self.adgroupSingleproduct.ads.push(self.adTypeObj);
                    } else {
                        self.adgroupSingleproduct.ads[self.adIndex] = self.adTypeObj;
                    }
                    self.showAdTypeForm = false;
                    self.adTypeObj = { };
                }
            } else {

            }
        }


        /*
         * Delete Ad Type
         */
        self.delAdType = function(index) {
            self.showAdTypeForm = false;
            self.adgroupSingleproduct.ads.splice(index, 1);
        }

        /*
         * Cancel AdType form 
         */
        self.cancelAdType = function() {
            self.showAdTypeForm = false;
            self.adTypeObj = { };
        }

        /* 
         * Initialize the component hide the add/edit operations based on showActions boolean value
         */
        self.initComponent = function() {
            if (self.adgroupSingleproduct) {
                if (typeof self.adgroupSingleproduct == "string" && self.adgroupSingleproduct !== "") {
                    self.adgroupSingleproduct = JSON.parse(self.adgroupSingleproduct);
                    self.initAdGroup();
                } else if (self.adgroupSingleproduct.length > 0) {
                    self.initAdGroup();
                } else {
                    self.newAdGroup();
                }
            } else if (self.showActions) {
                self.adgroupSingleproduct = [];
                self.newAdGroup();
            }
        };

        self.initComponent();
    }
});
